<script setup lang="ts">
import { onMounted } from "vue";

const props = defineProps<{ title: string }>();
onMounted(() => {
  document.title = props.title;
});
</script>
